<template>
    <div class="feed-list-new-container" :data-spm="config.spmCode ? config.spmCode : 'fd-d'">
        <RecommendFeed
            :data="feedDataList"
            :businessConfig="businessConfig"
            :canFeedback="config.canFeedback"/>
        <div>
            <footer class="feed-list__loading" v-show="loadingStatus === loadingStatusConfig.loading">
                <div class="loading icon icon-loading"></div>
                为您推荐中
            </footer>
            <footer class="feed-list__loading" v-show="loadingStatus === loadingStatusConfig.error">暂时没有更多内容了……</footer>
        </div>
        <RecommendFeedBack
            v-if="showFeedBack&&config.canFeedback"
            @handleClose="closeFeedback"
            :position="{x:positionX,y:positionY}"
            :data="feedbackItemData"
            :feedbackData="feedbackData"
            :isDoublePx="true"
            :feedbackConfig="feedbackConfig"
        />
        <div :class="['toast',showFBlink&& 'toast-jb']" v-if="canShowToast">
            {{toastText}}
            <template v-if="showFBlink">
                <span>可前往<a :href="myFeedBack">我的反馈</a>查看审核状态</span>
                <img @click="closeToast" src="../less/images/icon_close_empty41@2x.png"/>
            </template>
        </div>
    </div>
</template>

<script>
import { getFeedbackList } from '../utils/request'
import Helper from '../utils/helper.js'
import { commonFeedAd } from '../ad/pages/commonPageAd'
import getPcm from '../utils/get-pcm.js'
import { getOdinResourceIdMap,nullResourceId } from "@/config/odinResourceIds"
// 反馈组件
import RecommendFeedBack from 'common-components/lib/recommendFeedBack'
import 'common-components/lib/recommendFeedBack/index.css'
// 推荐阅读组件
import RecommendFeed from 'common-components/lib/recommendFeed'
import 'common-components/lib/recommendFeed/index.css'
import reportSearchWord from '../utils/getSearchWord'

import { getOdinData } from '@/js/request/odinRequest'
import { getUserInfo } from '@/js/request/uisRequest'

// 加载状态
const loadingStatusConfig = {
    default: 'default',  // 默认，未加载
    loading: 'loading',  // 加载中
    error: 'error'     // 数据为空or加载失败
}

const myFeedBackUrl = {
    'test':'//test-m.sohu.com/feedback/record',
    'pre':'//m.sohu.com/feedback/record',
    'prod':'//m.sohu.com/feedback/record',
}

// 文章等级 0：a,1：s- 2：s 3：s+
const isForbiddenAd = window.cfgs && window.cfgs.Sgrade >= 1

export default {
    name: "FeedListNew",
    components:{
        RecommendFeedBack,
        RecommendFeed
    },
    data(){
        return {
            productId: '',
            productType: '',
            resourceId: '',
            adInfo: {},
            feedDataList: [],
            feedbackConfig: {
                disgustedContTab: true, // 内容不感兴趣
                shieldAuthorTab: true, // 屏蔽该作者
                fbLowQualityTab: { // 反馈低质量内容
                    isShow: true, // 是否展示该tab
                    isCanFold: true, // 是否可以折叠
                    isInAudit: false, // 是否进入反馈后台
                    title: '反馈低质内容' // 低质量内容title
                }
            },
            spmData: window.MptcfeUtils?.Utils?.getSpm(),
            spm: Helper.urlToObj(document.location.href).spm || '', // spm码
            page: 1,
            loadingStatusConfig: loadingStatusConfig,
            loadingStatus: loadingStatusConfig.default,  //loading状态
            commonDataArr: [], // 内容流
            sspAd: [], // SSP广告数据
            showFeedBack: false, // 控制反馈框的显示隐藏
            positionX: 0, // 关闭按钮距离窗口顶部的距离X
            positionY: 0,// 关闭按钮距离窗口顶部的距离Y
            feedbackItemData: {}, // 反馈item的数据
            feedbackData: [],  // 反馈数据
            canShowToast: false,
            toastText:'',
            cause:0, // 反馈原因id
            isLogin: false,
            myFeedBack: myFeedBackUrl[window.env]
        }
    },
    props:{
        //文章ID
        articleId: {
            type: [ Number, String ],
            default: 0,
        },
        businessConfig: {
            type: Object,
            default () {
                return {}
            }
        },
        /**
         * @description 通用参数map
         * 目前包括：
         * resourcePage，表示使用场景是，目前是文章页场景会有特殊处理
         * maxShowNumber，表示feed流最多展示条数
         */
        config: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        // 弹框展示“我的反馈”链接
        showFBlink() {
            return this.cause > 2 && this.isLogin
        },
        maxShowNumber(){
            return this.config?.maxShowNumber || 40
        },
    },
    mounted(){
        this.getResourceId();
        // todo 若需要反馈弹框，获取相关数
        if(this.config.canFeedback) {
            eventBus?.$on('handleFeedbackItem',this.handleFeedbackItem)
            this.getFeedbackData()
        }
        this.init();
    },
    methods:{
        async init() {
            try {
                const res = await getUserInfo()
                this.isLogin = res?.code == 1 && res?.data
            } catch (error) {
                this.isLogin = false
            }
            this.loadOdinData()
        },

        // 请求参数
        getParams() {
            const spmObj = window?.sohuSpm?.getCodes()
            // 处理个性化参数
            let mkey = ''
            const searchWords = reportSearchWord(this.articleId)
            const originMkey = `channelId_${window.cfgs?.channelId}--mpid_${this.articleId}`
            mkey = Boolean(searchWords) ? `${originMkey}--words_${searchWords}` : originMkey
            // wcms文章页的个性化参数需要特殊处理，由于title与keywords在传递时是以中文的形式，会存在携带竖线的情况，这与本身mkey的格式冲突，会导致解析报错
            if(this.config && this.config.articleScene === 'wcms'){
                let title = window.cfgs?.title?.replaceAll("|","")
                let keywords = window.cfgs?.keywords?.replaceAll("|","")
                mkey = `channelId_${window.cfgs?.channelId}--mpid_${window.cfgs?.articleId}--title_${title}--keywords_${keywords}`
            }
            let artKeywords = window.cfgs?.keywords
            let adKeywords = []
            if ((typeof artKeywords=='object') && artKeywords && artKeywords.length > 0) {
                adKeywords = artKeywords.slice(0,6)
            }
            let spmCode = this.config.spmCode ? this.config.spmCode : 'fd-d'
            const params = {
                tplCompKey: "article-recommend-feed",
                adInfo: isForbiddenAd ? {} : this.adInfo,
                spmCCode: spmCode,
                resourceId: isForbiddenAd ? nullResourceId : this.resourceId,
                content: {
                    page: this.page,
                    size: this.maxShowNumber,
                    productId: this.productId,
                    productType: this.productType,
                    spm: `${spmObj?.a}.${spmObj?.b}.${spmCode}`
                },
                context: { mkey,adKeywords: adKeywords.join(' ')  }
            }
            return params
        },

        // 获取推荐流数据
        async loadOdinData() {
            try {
                this.loadingStatus = this.loadingStatusConfig.loading
                let pullTime = this.page
                const params = this.getParams()
                let data = await getOdinData(params)
                if(data?.list?.length) {
                    const {locations,array,sspAd} = this.formatData(data)
                    this.sspAd = sspAd
                    this.feedDataList = array
                    this.loadingStatus = this.loadingStatusConfig.default
                    this.$nextTick(()=>{
                        this.handleAd(pullTime)
                    })
                }else {
                    this.loadingStatus = this.loadingStatusConfig.error
                }
            } catch (error) {
                this.loadingStatus = this.loadingStatusConfig.error
            }
            
        },

        // 广告和统计处理
        handleAd(pullTime) {
            let items = this.getItemsByPullTime(pullTime)
            items.attr('data-spm-stop', 'nev') // 广告插入之前，先阻止打码
            let initNum = 2 //  先添加广告预占位
            this.sspAd.forEach(currentItem => {
                let sspAdWrap = document.createElement('li') // 创建广告位占位容器
                $(sspAdWrap).attr({
                    'data-spm-content': getPcm(currentItem),
                    'data-spm-type': 'content',
                    'data-lca': currentItem.location,
                    'pullTime': pullTime,
                    'data-spm-stop': 'nev',
                })
                // 当前位置的内容后添加广告
                let targetDomIndex = currentItem.position - initNum
                if(targetDomIndex < 0) {
                    $(items[0]).before(sspAdWrap)
                } else {
                    $(items[targetDomIndex]).after(sspAdWrap)
                }
                initNum += 1
            })
            // 如果有广告,则在广告dom生成后,删除占位框,并传入打码函数
            if (this.sspAd.length > 0) {
                commonFeedAd(this.sspAd, this.resourceId, () => {
                    this.setAutoStat(pullTime)
                })
            } else {
                this.setAutoStat(pullTime)
            }
        },

        getItemsByPullTime(pullTime) {
            return $(this.$el).find("[data-pull-time='" + pullTime + "']")
        },

        // 设置允许自动打码和发送统计
        setAutoStat(pullTime) {
            if(window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
                let items = this.getItemsByPullTime(pullTime)
                items.removeAttr('data-spm-stop')
                window.sohuSpm.domDidChange()
            }
        },
        // 格式化odin数据
        formatData(data) {
            try {
                let { backups,list } = data
                const locations = []
                const array = []
                const sspAd = []

                if(!list || list.length == 0) {
                    this.loadingStatus = this.loadingStatusConfig.error
                }else {
                    list = list.slice(0,this.maxShowNumber) //如果最终的数据长度大于最大展示条数，则做截断处理
                    for(let i = 0; i < list.length; i++){
                        let item = list[i]
                        const resourceData = item.resourceData || {}
                        const location = Number(item?.position)
                        if(resourceData.adType) {// 广告
                            const backupContent = backups?.[location-1] || {} // 打底内容
                            locations.push(item.position)
                            
                            const adResult = {
                                ...resourceData,
                                id: resourceData?.id || Date.now(),
                                pcm: resourceData?.pcm,
                                type: resourceData?.adType,
                                pullTime: 1,
                                location: location || 0,
                                position: location || 0,
                                resourceType: item.resourceType,
                                replaced: {
                                    ...backupContent
                                }
                            }
                            adResult.adData.lc = 1 //设置屏数
                            adResult.adData.position = i + 1 // position为当前索引+1
                            sspAd.push(adResult)
                        }else {
                            // 兼容"推荐阅读"组件数据格式
                            item.type = item.contentType
                            item.images = item.cover
                            item.mobileTitle = item.title
                            item.cover = item.cover&&item.cover[0]
                            item.publicTime = item.postTime
                            item.pullTime = 1
                            item.pcm = ''
                            if(item.type == 3) item.isPicture = true; // 3:图集
                            if(item.businessType == 1&&(item.type === 4 || item.type === 5)) item.hasVideoTag = true;
                            // 特殊文章页更改url
                            if(this.config?.urlTag) {
                                item.url = item.url.replace('/a/',this.config.urlTag)
                            }
                            array.push(item)
                        }
                    }
                }
                return {
                    locations,
                    array,
                    sspAd
                }
            } catch (error) {
                console.log('format odin 推荐阅读',error)
            }
        },

        // 获取productId,resourceId,adInfo
        getResourceId(){
            let articleScene = this.config.articleScene || 'normal'

            const articleSceneMap = {
                normal: 'normalRecFeed', // 常规
                special: 'normalSpecialRecFeed', // 编辑精选流
                international: 'normalInternationalRecFeed', // 国际新闻流
                wx: 'wxRecFeed', // 微信
                abroad: 'normalRecFeed', // 海外
                hsdt: 'hsdtRecFeed',  // 花生地铁
                wcms: 'wcmsRecFeed', // wcms
                heisha: 'heishaRecFeed', // 黑鲨
                hltq: 'hltqRecFeed', // 黄历天气
            }
            const senceKey = articleSceneMap?.[articleScene]
            const idsMap = getOdinResourceIdMap(senceKey)

            this.productId = idsMap?.productId
            this.productType = idsMap?.productType
            this.resourceId = idsMap?.resourceId
            this.adInfo = idsMap?.adInfo
        },

        handleFeedbackItem(obj) {
            this.showFeedBack = true
            this.positionX = obj?.positionX || 0
            this.positionY = obj?.positionY || 0
            this.feedbackItemData = obj?.data || {}
        },

        // 处理反馈弹框的显示隐藏
        closeFeedback(obj) {
            this.showFeedBack = false
            const id = obj?.id
            const status = obj?.status
            this.cause = obj?.cause || 0
            if(status && id) {
                if(this.cause && this.cause < 3) {
                    this.toastText = '感谢反馈！将减少类似内容推荐'
                }else {
                    this.toastText = '感谢反馈！已提交审核处理'
                }
                // 隐藏当前这条数据
                this.hideDom(id)
            }
        },
        hideDom(id) {
            var element = document.querySelector(`.feed-list-new-container .feed-list-scoped  [data-id='${id}']`)
            if(element) {
                element.classList.add("fadeOut")
                setTimeout(()=>{
                element.classList.add("hidden")
                this.showToast()
                },200)
            }
        },
        showToast() {
            this.canShowToast = true
            if(!this.showFBlink) {
                setTimeout(()=>{
                    this.canShowToast = false
                },1000)
            }
        },
        getFeedbackData() {
            const params = {
                sceneId: 1
            }
            getFeedbackList(params).then((res)=>{
                if(res?.data?.length){
                    this.feedbackData = res.data
                }
            })
        },
        closeToast() {
            this.canShowToast = false
        }
    },
}
</script>

<style lang="less" rel="stylesheet/less">
.toast {
        position: fixed;
        z-index: 999;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        width: 420px;/*px*/
        height: 72px;/*px*/
        background-color: rgba(0, 0, 0, 0.7);
        border-radius: 4px;/*px*/
        font-size: 28px;/*px*/
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;/*px*/
        color: #FFFFFF;
        line-height: 72px;/*px*/
        text-align: center;
    }
    .toast-jb {
        width:400px;/*px*/
        height: 184px;/*px*/
        padding: 32px 54px;/*px*/
        line-height: 40px;/*px*/
        box-sizing: border-box;
        a {
            color: #FFD200;
            text-decoration:underline;
        }
        img {
            position: absolute;
            right: 4px;/*px*/
            top: 4px;/*px*/
            width: 24px;/*px*/
            height: 24px;/*px*/
        }
    }
    .load-more-btn {
        position: relative;
        top: -1px; /*no*/
        display: block;
        padding: 40px 0;
        text-align: center;
        background-color: #ffffff;
        span, i{
            vertical-align: middle;
            font-size: 24px; /*px*/
            color: #999999;
        }
    }

    .feed-list__loading {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #a4a4a4;
        font-size: 24px; /*px*/
        padding: 40px 0;
        .loading {
            margin-right: 12px;
            font-size: 26px;
            color: #a4a4a4;
            animation: loading .8s linear infinite;
        }
    }

    .feed-list-new-container > div:nth-last-child(2) > a:last-child > div{
        color: red;
        border-bottom: 0;
    }
    .hidden {
        display: none !important;
    }
    .fadeOut {
        opacity:0;
        transition: opacity 0.5s;
    }
    .uc-wrap {
        border-bottom: 1px solid #f0f0f0;
    }

    @keyframes loading {
        0% {
            transform: rotate(0deg) translateZ(0);
        }
        100% {
            transform: rotate(360deg) translateZ(0);
        }
    }
</style>
